import React from 'react';
import PropTypes from 'prop-types';
import pick from 'lodash/pick';
import { uploadFile } from 'pages/Upload/utils';
import { GENERAL_DISEASE } from 'utils/constants/disease';
import { UploadFlow } from './UploadFlow';

export const CurrentUserUploadPopup = ({
  onSuccess,
  onUpdate,
  onBeforeIntake,
  condition,
  generalDiseaseSubType,
  onUploadedFilesChange,
  presentNgsNotFound = false,
}) => {
  const handleUpload = ({
    files,
    getRecaptchaTokenAsync,
    onUpload,
    onError,
  }) => uploadFile({
    files,
    getRecaptchaTokenAsync,
    onUpload,
    onError,
    condition: condition === GENERAL_DISEASE ? generalDiseaseSubType : condition,
    noUserProfileMerge: true,
  });

  const handleUploadedFiles = (files, { jobId }) => onUploadedFilesChange(
    // to get rid of file blob
    files.map((file) => pick(file, ['name', 'storageName'])),
    { jobId, source: 'upload' },
  );

  return (
    <UploadFlow
      condition={condition}
      onSuccess={onSuccess}
      onUpdate={onUpdate}
      onBeforeIntake={onBeforeIntake}
      onUploadFiles={handleUpload}
      onUploadedFilesChange={handleUploadedFiles}
      presentNgsNotFound={presentNgsNotFound}
    />
  );
};

CurrentUserUploadPopup.propTypes = {
  onSuccess: PropTypes.func,
  onUpdate: PropTypes.func,
  condition: PropTypes.string,
  generalDiseaseSubType: PropTypes.string,
  onBeforeIntake: PropTypes.func,
  onUploadedFilesChange: PropTypes.func.isRequired,
  presentNgsNotFound: PropTypes.bool,
};
